import { useState } from "react";
import {
  Drawer, DrawerContent, DrawerHeader, DrawerTitle,
} from "../components/ui/drawer";
import { NewQuoteSheet } from "./NewQuoteSheet";
import { useCart } from "../context/CartContext";
import { Check, Plus, Receipt } from "@phosphor-icons/react";

export function QuoteSwitcherSheet({ open, onOpenChange }) {
  const { carts, activeCartId, setActiveCartId } = useCart();
  const [newQuoteOpen, setNewQuoteOpen] = useState(false);

  return (
    <>
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent className="mobile-app rounded-t-[28px] border-[#E7E5E4] max-h-[75vh]" data-testid="mobile-quote-switcher-sheet">
          <DrawerHeader>
            <DrawerTitle className="font-display text-2xl text-[#1C1917]">Add Items To</DrawerTitle>
          </DrawerHeader>
          <div className="px-5 pb-3 overflow-y-auto space-y-2 max-h-[50vh]">
            {[...carts].reverse().map((cart) => (
              <button
                key={cart.id}
                onClick={() => { setActiveCartId(cart.id); onOpenChange(false); }}
                data-testid={`mobile-quote-switcher-option-${cart.id}`}
                className="w-full flex items-center gap-3 bg-white border border-[#E7E5E4] rounded-[16px] p-3.5 text-left transition-colors duration-200"
              >
                <div className="w-9 h-9 rounded-full bg-[#1E3A8A]/8 flex items-center justify-center flex-shrink-0">
                  <Receipt size={18} weight="duotone" className="text-[#1E3A8A]" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-base font-medium text-[#1C1917] truncate">{cart.name}</p>
                  <p className="text-xs text-[#78716C]">{cart.item_count} items</p>
                </div>
                {activeCartId === cart.id && <Check size={18} weight="bold" className="text-[#1E3A8A] flex-shrink-0" />}
              </button>
            ))}
          </div>
          <div className="px-5 pb-6 pt-1">
            <button
              onClick={() => setNewQuoteOpen(true)}
              data-testid="mobile-quote-switcher-new-quote"
              className="press-scale w-full h-13 rounded-[16px] border-2 border-dashed border-[#1E3A8A]/30 text-[#1E3A8A] font-semibold flex items-center justify-center gap-2 transition-colors duration-200"
            >
              <Plus size={18} weight="bold" /> New Quotation
            </button>
          </div>
        </DrawerContent>
      </Drawer>
      <NewQuoteSheet open={newQuoteOpen} onOpenChange={(v) => { setNewQuoteOpen(v); if (!v) onOpenChange(false); }} />
    </>
  );
}
